import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils';

export type ToggleChipProps = Omit<ComponentProps<'button'>, 'type'> & {
  pressed: boolean;
};

/** Pill that is on or off (filters, time ranges, series): `aria-pressed`, primary when on. */
export function ToggleChip({ pressed, className, children, ...props }: ToggleChipProps) {
  return (
    <button
      type="button"
      aria-pressed={pressed}
      className={cn(
        'inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border px-3 py-1 text-xs font-medium transition-colors outline-none focus-visible:ring-[3px] focus-visible:ring-ring/50 disabled:pointer-events-none disabled:opacity-50 [&_svg]:size-3.5 [&_svg]:shrink-0',
        pressed
          ? 'border-primary/40 bg-primary/10 text-primary'
          : 'border-border text-muted-foreground hover:border-primary/30 hover:text-foreground',
        className
      )}
      {...props}
    >
      {children}
    </button>
  );
}
